<ziro-breadcrumbs>
  <ziro-breadcrumb-card-item [aboutCardId]="38"></ziro-breadcrumb-card-item>
</ziro-breadcrumbs>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

@if (!isLoading) {
  <ziro-datatable
    [rowDataSource]="rows"
    [columns]="columns"
    [uniqueRowIdentifier]="'id'"
    [dataAutomation]="tableAutomationId"
    [showCustomAlert]="true"
    [setColumnWidths]="false"
    [class]="'ziro-card'"
  >
    <ziro-datatable-multi-select-filter
      [label]="'tkey;admin.msdialplan.management.pstn_connectivity_type.label'"
      [items]="pstnConnectivityTypeOptions()"
      [dataAutomation]="'pstn-filter'"
      [tableId]="tableAutomationId"
      [matchFn]="isPstnMatch"
    ></ziro-datatable-multi-select-filter>
    <div
      alert-content
      [innerHtml]="'tkey;admin.msdialplan.management.group_list.no_results' | escapeHtml: {
            url: `#/admin/tenants/${this.tenantInfo.tenantId}/dial-plan-management/new-group`
        }"
    ></div>
  </ziro-datatable>
}
